import en from './en.translations.json.js';
import de from './de.translations.json.js';
import fr from './fr.translations.json.js';
import it from './it.translations.json.js';
import es from './es.translations.json.js';
import nl from './nl.translations.json.js';

const uiPaginationTranslationsDe = { ...de };
const uiPaginationTranslationsEn = { ...en };
const uiPaginationTranslationsEs = { ...es };
const uiPaginationTranslationsFr = { ...fr };
const uiPaginationTranslationsIt = { ...it };
const uiPaginationTranslationsNl = { ...nl };
const uiPaginationTranslationsBundle = {
  de: uiPaginationTranslationsDe,
  en: uiPaginationTranslationsEn,
  es: uiPaginationTranslationsEs,
  fr: uiPaginationTranslationsFr,
  it: uiPaginationTranslationsIt,
  nl: uiPaginationTranslationsNl
};

export { uiPaginationTranslationsBundle, uiPaginationTranslationsDe, uiPaginationTranslationsEn, uiPaginationTranslationsEs, uiPaginationTranslationsFr, uiPaginationTranslationsIt, uiPaginationTranslationsNl };
